import { Component, input } from '@angular/core';

@Component({
  selector: 'rt-sidebar-label',
  templateUrl: './sidebar-label.component.html',
  styleUrls: ['./sidebar-label.component.less'],
  standalone: true,
})
export class SidebarLabelComponent {
  public readonly label = input<string>(undefined!);
}
